import PropTypes from "prop-types";
import Lead from "components/shared/stays/Lead";
import Title from "components/shared/stays/Title";
import Truncate from "solar/components/Truncate";
import styles from "components/stay/Story.module.scss";

export default function Story({ header, body, teammate, guide }) {
  return (
    <div className={styles.component}>
      <Title size={3}>{header}</Title>
      <Lead className={styles.body}>
        <Truncate chars={600} more>
          {`"${body}"`}
        </Truncate>
      </Lead>
      <div className={styles.byline}>
        <span>&mdash; </span>
        {teammate && (
          <>
            {teammate}
            {", "}
          </>
        )}
        {guide}
      </div>
    </div>
  );
}

Story.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  teammate: PropTypes.string.isRequired,
  guide: PropTypes.string.isRequired,
};
